<template>
  <div class="bg-white">
  <div class="w w1200">
    <div class="good-card">
      <div class="good-img-box">
        <div class="img-preview">
          <magnifier :url="currentUrl" :videoPoster="bigphotos"></magnifier>
        </div>
        <div class="good-img-nav">
          <div class="nav-item" @click="selectedImg(url)"
               v-for="url in moreImgArr" :key="url" :class="{'active': currentUrl === url}">
            <template v-if="isVideo(url)">
              <i class="el-icon-video-play"></i>
              <el-image :src="moreImgArr[1]" fit="contain" alt=""></el-image>
            </template>
            <template v-else>
              <el-image :src="url" fit="contain" alt=""></el-image>
            </template>
          </div>
        </div>
      </div>
      <div class="good-information">
        <h1 class="good-title"><span class="tag" v-if="info.tag">{{ info.tag }}</span>{{ info.name }}</h1>
        <p class="market-tips">{{ info.adWord }}</p>
        <div class="introduce">
          <div class="introduce-group">
            <label class="introduce-group-label">价格</label>
            <div class="introduce-group-val good-price">{{ currentSku.price | decimal }}</div>
          </div>
          <div class="introduce-group">
            <label class="introduce-group-label">市场价</label>
            <div class="introduce-group-val market-price">￥{{ currentSku.marketprice | decimal }}</div>
          </div>
          <div class="introduce-group" v-for="item in attributeList" :key="item.bXySid">
            <label class="introduce-group-label attr-label">{{item.name}}</label>
            <div class="introduce-group-val">
                <el-radio-group v-model="item.selectedId" @change="getSkuPrice">
                  <el-radio size="small" border :label="attr.id"
                            v-for="attr in item.attributeList" :key="attr.id">{{attr.name}}</el-radio>
                </el-radio-group>
            </div>
          </div>
          <div class="introduce-group">
            <label class="introduce-group-label">数量</label>
            <div class="introduce-group-val" v-if="info">
              <el-input-number v-model="info.number" :min="1" :max="Number(currentSku.stock)"></el-input-number>
              <span class="stock">库存：{{currentSku.stock}}件</span>
            </div>
          </div>
        </div>
        <div class="btn-box">
          <el-button class="btn-custom" disabled plain v-if="storeInfo && storeInfo.shutStatus === 'PUBLICITY'">商品已下架！</el-button>
          <template v-else>
            <el-button :disabled="showModel" class="btn-custom" type="primary" plain @click="orderNow">立即购买</el-button>
            <el-button :disabled="showModel" class="btn-custom" type="primary" @click="onAddCar" v-if="info.type === 1">加入购物车</el-button>
          </template>
        </div>
        <div class="tips" v-if="showModel"><i class="el-icon-info"></i> 当前预览模式，不可购买</div>
      </div>
    </div>
    <div class="collect-btns">
      <div class="btn-collect" :class="{'active': info.isCollect === 1}" @click="toggleCollect">
        <i class="el-icon-star-on" v-if="info.isCollect === 1"></i>
        <i class="el-icon-star-off" v-else></i>
        <span class="state">{{info.isCollect === 1 ? '已收藏' : '收藏'}}</span>
      </div>
    </div>
    <div class="fixedTabs" :class="{'show': searchBarFixed}">
      <div class="tab-inner w w1200">
        <div class="tab shop"><i class="el-icon-s-shop"></i> {{storeInfo.name}}</div>
        <div class="tab" :class="{'active': activeTab === '0'}" @click="tabChange('0')">商品详情</div>
        <div class="tab" :class="{'active': activeTab === '1'}" @click="tabChange('1')">商品评价</div>
        <div class="tab" :class="{'active': activeTab === '2'}" @click="tabChange('2')">商品咨询<span v-if="goodsAdviceList.length">（{{goodsAdviceList.length}}）</span></div>
        <div class="tab" :class="{'active': activeTab === '3'}" @click="tabChange('3')">商家介绍<span v-if="goodsCommentList.length">（{{goodsCommentList.length}}）</span></div>
      </div>
    </div>
    <el-row :gutter="10">
      <el-col :span="4">
        <shopStoreItem :shopInfo='storeInfo' :isshow="1"></shopStoreItem>
        <hotGoods navTitle="热卖商品"></hotGoods>
      </el-col>
      <el-col :span="20">
        <el-tabs v-model="activeTab" class="goods-tabs" type="card">
          <el-tab-pane name='0'>
            <span slot="label" class="goodsTabs">商品详情</span>
            <div class="goodsDetail" v-html="info.description"></div>
            <el-image class="goodFoot" :src="goodFoot"></el-image>
          </el-tab-pane>
          <el-tab-pane name='1'>
            <span slot="label" class="goodsTabs"> 商品评价<span v-if="goodsCommentList.length">（{{goodsCommentList.length}}）</span></span>
            <el-row :gutter="20" class="goodsCommentList" v-for="item in goodsCommentList" :key="item.bXyDoeid">
              <el-col :span="2">
                <el-avatar :size="60" src="" @error="errorHandler"></el-avatar>
                <div>{{ item.nickname | nameHide }}</div>
              </el-col>
              <el-col :span="22">
                <el-rate disabled v-model="item.starLevel"></el-rate>
                <p class="goodsCommentList_content">{{ item.content }}</p>
                <el-image class="commentListImg" v-for="imgItem in item.images" :src="imgItem" :key="imgItem"
                          :preview-src-list="item.images">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="lastLine">
                  <div class="goodsCommentList_goodsName">
                    <p class="goodsNameText OneLineDisplay" :title="item.goodsName">{{ item.goodsName }}</p>
                    <span style="margin-left:20px"> {{ item.createTime }}</span>
                  </div>
                  <div class="goodsCommentList_opreate">
                    <i @click="showReplay(item)" class="el-icon-chat-dot-round"></i>
                  </div>
                </div>
                <div class="repalyBox" v-show="item.showRepalyBox">
                  <el-input placeholder="回复楼主" v-model="replayContent" class="goods_advisory_input">
                    <el-button slot="append" class="advisory_button" @click="replayHandle(item)">回复</el-button>
                  </el-input>
                </div>
                <!-- 某条评论下的回复 -->
                <template v-if="item.replyList.length">
                  <div class="subReplay" v-for="replayItem in item.replyList" :key='replayItem.id'>
                    <div class="subReplay-content">
                      <span class="nickname">{{replayItem.nickname | phoneEncryption}}：</span>
                      <div class="replay-content">{{ replayItem.content }}</div>
                    </div>
                    <div class="subReplay-time">{{ replayItem.createTime }}</div>
                  </div>
                </template>
              </el-col>
            </el-row>
            <Pagination v-bind:child-msg="commentPager" @callFather="handlePageChange"></Pagination>
          </el-tab-pane>
          <el-tab-pane name='2'>
            <span slot="label" class="goodsTabs"> 商品咨询<span v-if="goodsAdviceList.length">（{{goodsAdviceList.length}}）</span></span>
            <div class="goods_advisory">
              <el-input placeholder="请输入内容" v-model="inputContent" class="goods_advisory_input">
                <el-button slot="append" class="advisory_button" @click="advisoryHandle()">提问</el-button>
              </el-input>
            </div>
            <div class="goods_adviceList">
              <template v-for="item in goodsAdviceList">
                <el-row :key="item.bXyDaid">
                  <el-col :span="12">
                    <span class="textRight askText">问</span>
                    <span class="textRight">{{ item.content }}</span>
                  </el-col>
                  <el-col :span="12" class="goods_adviceList_right">
                    <span class="textRight">{{ item.name }}</span>
                    <span class="textRight">{{ item.createTime }}</span>
                  </el-col>
                </el-row>
                <div class="answer-card">
                  <template v-if="item.bxyDealAdvisoryReplyList.length">
                    <el-row v-for="answer in item.bxyDealAdvisoryReplyList" :key="answer.bXyDarid">
                      <el-col :span="12">
                        <span class="textRight askText replayText">答</span>
                        <span class="textRight">{{ answer.content }}</span>
                      </el-col>
                      <el-col :span="12" class="goods_adviceList_right">
                        <span class="textRight">{{ answer.name }}</span>
                        <span class="textRight">{{ answer.createTime }}</span>
                      </el-col>
                    </el-row>
                  </template>
                  <el-row v-else>
                    <el-col :span="12">
                      <span class="textRight askText replayText">答</span>
                      <span class="textRight">暂无回答</span>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <!-- 提问弹框 -->
    <el-dialog
      class="addCartBox"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <div style="text-align: center" v-show="successInfo">
        <div class="addGoodsInfo">提问成功</div>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="centerDialogVisible = false">继续购物</el-button> -->
          <el-button type="primary" @click="centerDialogVisible = false">继续浏览</el-button>
        </span>
      </div>
      <div style="text-align: center" v-show="!successInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false">确定</el-button>
        </span>
      </div>
    </el-dialog>

    <!-- 回复 开始 -->
    <el-dialog
      class="addCartBox"
      :visible.sync="addReplayVisible"
      width="30%"
      center>
      <div style="text-align: center" v-show="relaysuccessInfo">
        <div class="addGoodsInfo">评论成功,等待客服进行处理!</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addReplayVisible = false">确定</el-button>
        </span>
      </div>
      <div style="text-align: center" v-show="!relaysuccessInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addReplayVisible = false">确定</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 回复 结束 -->
  </div>
  </div>
</template>
<script>
import magnifier from '@/components/magnifier'
import hotGoods from '@/components/hotGoods'
import shopStoreItem from '@/components/shopStoreItem'
import countDown from '@/components/countDown'
import Pagination from "../../components/Pagination";
import {
  fetchGoodSkus,
  commoditylist,
  addShoppingCart,
  storeList,
  removeCollection,
  addCollection,
  goodsAdvice,
  addgoodsAdvice,
  commentList,
  replayComment,
  footprint_add
} from "../../api/xunyou";
import {mapState} from 'vuex';
export default {
  name: 'goodDetail',
  data() {
    return {
      videoType: 'mp4 avi dat 3gp mov rmvb',
      moreImgArr: [],
      bigphotos: '',
      info: '',
      centerDialogVisible: false,
      successInfo: true,
      inputContent: '',
      storeInfo: '',
      attributeList: [],
      skus: null,
      currentSku: '',
      currentUrl: '',
      goodsAdviceList: [], // 商品咨询
      activeTab: '0',
      searchBarFixed: false,
      //  商品评价
      addReplayVisible: false,
      relaysuccessInfo: true,
      replayContent: '',
      goodsCommentList: [],
      commentPager: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  // 注册组件
  components: {magnifier, hotGoods, shopStoreItem, countDown, Pagination},
  computed: {
    ...mapState(['getprovince', 'currentAddress']),
    userId () {
      return this.$store.getters.userId;
    },
    goodId () {
      return this.$route.query.id;
    },
    selectedAttrIds () {
      return this.attributeList.map(ele => ele.selectedId);
    },
    enableGood () {
      return this.info.status === 1 && this.info.approvalStatus === 1 && this.currentSku.stock > 0;
    },
    showModel () {
      return this.$route.query.showModel;
    },
    goodFoot () {
      return this.$store.state.staticPath + '/app/good-foot.jpeg'
    },
  },
  watch: {
    '$route': function (to, from) {
      console.log('路由数据：', to);
      this.getGoodsCommentList()
      this.getCommodityDetail();
      this.getGoodsAdvice();
      this.getGoodSkus();
    }
  },
  created() {
    this.getGoodsCommentList()
    this.getCommodityDetail();
    this.getGoodsAdvice();
    this.getGoodSkus();
    this.addViewHistory();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 新增浏览历史
    addViewHistory () {
      const params = {
        fid: this.goodId,
        uid: this.$store.getters.userId
      };
      footprint_add(params).then(res => {
        console.log('浏览历史新增：', res);
      });
    },
    // 是否是视频
    isVideo (url) {
      const arr = url.split('.');
      const suffix = arr[arr.length - 1];
      return this.videoType.indexOf(suffix) > -1;
    },
    // 滚动
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.searchBarFixed = scrollTop > 880
    },
    //   选择的图片 mp4 avi dat 3gp mov rmvb
    selectedImg(url) {
      this.currentUrl = url;
    },
    // 切换收藏状态
    toggleCollect() {
      const params = {
        type: 1, // 1:商品；2：店铺；必填
        uid: this.userId,
        cid: this.info.id
      }
      let promise = null;
      if (this.info.isCollect === 1) {
        this.info.isCollect = 0;
        promise = removeCollection(params);
      } else {
        this.info.isCollect = 1;
        promise = addCollection(params);
      }
      promise.then(res => {
        console.log('收藏结果：', res);
      }).catch(err => {
        this.$message.error("操作失败，请稍后再试！");
      });
    },
    // 店铺查询
    searchStoreList() {
      storeList({
        userId: this.userId,
        bxmId: this.info.mid,
      }).then((res) => {
        console.log('店铺信息：', res);
        if (res.code === 0) {
          this.storeInfo = res.rows[0];
        }
      }).catch((err) => {
        this.$message.error("店铺查询失败，请稍后再试！");
      });
    },
    // 获取商品sku列表
    getGoodSkus() {
      fetchGoodSkus({productId: this.goodId}).then(res => {
        console.log('规格列表：', res);
        if (res.code === 0) {
          if (res.data.skus) {
            this.skus = res.data.skus;
          }
          if (res.data.specifications) {
            this.attributeList = res.data.specifications.map(ele => {
              if (ele.attributeList && ele.attributeList.length) {
                ele['selectedId'] = ele.attributeList[0].id;
                ele['selectedName'] = ele.attributeList[0].name;
              }
              return ele;
            });
          }
          this.getSkuPrice();
        }
      }).catch(error => {
        console.log('错误：', error);
        this.$message.error('查询规格列表失败，请稍后再试！')
      });
    },
    // 商品详情查询
    getCommodityDetail() {
      const params = {
        id: this.goodId,
        stype: '',
        userId: this.userId || ''
      }
      if (this.showModel) {
        params['showModel'] = this.showModel;
      }
      this.loading = true;
      commoditylist(params).then((res) => {
        console.log('商品详情：', res);
        this.loading = false;
        if (res.code === 0) {
          this.info = res.rows[0];
          this.moreImgArr = res.rows[0].more_photos ? res.rows[0].more_photos.split(',') : [];
          this.bigphotos = this.moreImgArr.length ? this.moreImgArr[0] : '';
          if (res.rows[0].video) {
            this.moreImgArr.unshift(res.rows[0].video);
          }
          this.currentUrl = this.moreImgArr[0];
          this.searchStoreList();
        }
      }).catch((err) => {
        console.error('->', err);
        this.loading = false;
        this.$message.error("查询商品失败，请稍后再试！");
      });
    },
    // 选规格价格发生变化
    getSkuPrice() {
      const key = this.selectedAttrIds.sort().join('');
      this.currentSku = this.skus[key];
      if (this.currentSku.image) {
        this.currentUrl = this.currentSku.image.split(',')[0];
      }
    },
    // 加入购物车
    onAddCar() {
      if (!this.enableGood) {
        this.$message.warning('库存不足！')
        return ;
      }
      this.$tools.isLogin(() => {
        if (this.info.status !== 1 || this.info.approvalStatus !== 1) {
          this.$message.error('暂时缺货');
          return ;
        }
        addShoppingCart({
          cid: this.goodId,
          uid: this.userId,
          updType: 'OFFSET',
          number: this.info.number,
          bxysid: this.currentSku.id
        }).then((res) => {
          console.log('新增购物车结果：', res);
          if (res.code === 0) {
            this.successTips();
            this.$store.dispatch('getCartList');
          }
        }).catch((err) => {
          this.$message.error("添加购物车失败，请稍后再试！");
        });
      });
    },
    successTips() {
      this.$confirm(`商品<strong style="color: #f43434;margin: 0 5px;">[${this.info.name}]</strong>加入购物车成功！`,
        '加入成功', {
          confirmButtonText: '去购物车结算',
          cancelButtonText: '继续购物',
          type: 'success',
          center: true,
          customClass: 'addCartSuccess',
          dangerouslyUseHTMLString: true
        }).then(() => {
        this.$router.push('/shoppingcart');
      }).catch(() => {});
    },

    // 立即下单
    orderNow() {
      if (!this.enableGood) {
        this.$message.warning('库存不足！')
        return ;
      }
      const good = [{
        bxmId: this.info.mid,
        goods: [{
          number: this.info.number,
          skuId: this.currentSku.id
        }]
      }];
      if (good.length) {
        this.$store.commit('SAVE_SELECTED_GOODS', good);
        this.$router.push('/orderDetail');
      }
    },

    //   切换tab
    tabChange(index) {
      this.activeTab = index;
    },
    // 获取头像失败
    errorHandler() {
      return true
    },
    handlePageChange(data) {
      this.commentPager.pageNum = data.currentPage
      this.commentPager.pageSize = data.pageSize
      this.getGoodsCommentList();
    },
    // 获取评价列表
    getGoodsCommentList() {
      commentList({
        pageNum: this.commentPager.currentPage,
        pageSize: this.commentPager.pageSize,
        goodId: this.goodId,
        type: 2,//1.店铺评级，2.商品评价
      }).then((res) => {
        if (res.code === 0) {
          this.commentPager.total = res.total;
          this.goodsCommentList = res.rows.map(ele => {
            ele.images = ele.images.split(',');
            return ele;
          });
        }
      }).catch((err) => {
        console.error(err);
        this.$message.error("查询商品评价失败，请稍后再试！");
      });
    },

    // 点赞
    likeHadle(id) {

      this.goodsCommentList.forEach((item) => {
        if (item.bXyDoeid == id && item.isLike == false) {
          item.likepoint = item.likepoint + 1
          item.isLike = !item.isLike
        } else if (item.bXyDoeid == id && item.isLike == true) {
          item.likepoint = item.likepoint == 0 ? 0 : item.likepoint - 1
          item.isLike = !item.isLike
        }
      })
    },
    showReplay(item) {
      item.showRepalyBox = !item.showRepalyBox;
    },
    // 回复
    replayHandle(item) {
      if (!this.replayContent) return ;
      this.$tools.isLogin(() => {
        replayComment({
          bXyDoeid: item.bXyDoeid,
          uid: this.userId,
          content: this.replayContent
        }).then((res) => {
          if (res.code === 0) {
            this.getGoodsCommentList();
            this.replayContent = '';
            item.showRepalyBox = false;
          }
        }).catch((err) => {
          console.error(err);
          this.$message.error("回复评论失败，请稍后再试！");
        });
      });
    },
    // -------------- 商品评价 开始 -------------------------//

    // -------------- 商品咨询 开始 -------------------------//
    getGoodsAdvice() {
      goodsAdvice({
        goodsId: this.$route.query.id || '',
      }).then((res) => {
        console.log('咨询：', res);
        if (res.code == 0) {
          this.goodsAdviceList = res.rows
          this.adviceLength = this.goodsAdviceList.length
        }
      }).catch((err) => {
        this.$message.error("3查询商品列表失败，请稍后再试！");
      });
    },

    // 提问
    advisoryHandle() {
      if (this.userId == undefined) {
        this.$message.error("请登录！");
        setTimeout(() => {
          this.$router.push('/login')
        }, 2000)
        return
      }
      if (this.inputContent == '') {
        this.$message({
          type: 'info',
          message: '请输入提问内容'
        })
        return
      }
      addgoodsAdvice({
        goodsId: this.$route.query.id || '',
        content: this.inputContent,
        uid: this.userId
      })
        .then((res) => {
          if (res.code == 0) {
            this.getGoodsAdvice()
            this.inputContent = ''
            this.centerDialogVisible = true;
          }
        })
        .catch((err) => {
          this.$message.error("4查询商品列表失败，请稍后再试！");
        });

    },
    // -------------------- 商品咨询 结束 ----------------------------------//
  },
};
</script>

<style lang="less" scoped>
.bg-white{
  background-color: #fff;
}
.subReplay{
  border-top: 1px solid #ECECEC;
  padding: 10px 0;
  .subReplay-content{
    .nickname{
      width: 80px;
      float: left;
      font-weight: 500;
    }
  }
  .subReplay-time{
    color: #888888;
    margin-top: 5px;
  }
}
.good-card{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding-top: 40px;
  background-color: #fff;
  .good-img-box{
    width: 440px;
    height: auto;
    .img-preview{
      width: 440px;
      height: 440px;
    }
    .good-img-nav{
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      overflow-x: auto;
      margin-top: 10px;
      padding-bottom: 15px;
      .nav-item{
        flex-basis: 60px;
        flex-shrink: 0;
        height: 60px;
        position: relative;
        margin-right: 10px;
        border: 1px solid #eaeefb;
        cursor: pointer;
        /deep/ .el-image{
          width: 100%;
          height: 100%;
        }
        .el-icon-video-play{
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 1;
          font-size: 2em;
          font-weight: bold;
          color: #ffffff;
          transform: translate3d(-50%, -50%, 0);
          box-shadow: 0px 0px 0px 19px rgba(38, 38, 38,0.3)
        }
      }
    }
  }
  .good-information{
    flex: 1;
    padding: 0 20px;
    font-size: 14px;
  }
  .tag {
    font-size: 14px;
    color: #ffffff;
    border-radius: 4px;
    padding: 0 3px;
    margin-right: 5px;
    background-color: var(--main-theme-color);
    vertical-align: middle;
  }
  .tips{
    margin-top: 10px;
    color: var(--main-theme-color);
  }
  .market-tips {
    margin-bottom: 5px;
    margin-top: 10px;
    color: var(--main-theme-color);
  }
  .introduce{
    background-position: 0 0;
    background-size: 100% 100%;
    padding: 10px 20px;
  }
  .introduce-group{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    .introduce-group-label{
      display: inline-block;
      width: 60px;
      height: 28px;
      line-height: 28px;
      color: #888888;
      text-align: justify;
      margin-right: 15px;
      &.attr-label{
        align-self: flex-start;
        height: 40px;
        line-height: 40px;
      }
      &:after{
        display: inline-block;
        width: 100%;
        content: "";
      }
    }
    .introduce-group-val{
      flex: 1;
      /deep/ .el-radio.is-bordered{
        margin-right: 10px;
        margin-bottom: 10px;
        box-sizing: border-box;
        font-family: 'element-icons' !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        vertical-align: baseline;
        display: inline-block;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        &.el-radio--small{
          padding: 8px 20px 0 20px;
        }
        &.is-checked{
          border-width: 2px;
          &:before{
            content: '';
            position: absolute;
            bottom: 0;
            right: 0;
            width: 0;
            height: 0;
            border: 10px solid;
            border-color: transparent var(--main-theme-color) var(--main-theme-color) transparent;
          }
          &:after{
            content: "\e6da";
            position: absolute;
            bottom: 0;
            right: 0;
            font-size: 12px;
            font-weight: bold;
            color: #fff;
          }
        }
        &+.el-radio.is-bordered{
          margin-left: 0;
        }
        .el-radio__input{
          display: none;
        }
        .el-radio__label{
          padding-left: 0;
          font-weight: 500;
        }
      }

    }
    .market-price{
      text-decoration: line-through;
      color: #666666;
    }
    .good-price{
      color: var(--main-theme-color);
      font-size: 20px;
      font-weight: bold;
      &:before{
        content: '￥';
        font-size: 14px;
      }
    }
  }
  .btn-box{
    margin-top: 30px;
    .btn-custom{
      width: 180px;
    }
  }
}
.collect-btns {
  padding: 10px 0;
  background-color: #fff;
  .btn-collect{
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    border: 1px solid #eaeefb;
    border-radius: 5px;
    padding: 5px 25px;
    color: #8c8e96;
    cursor: pointer;
    &.active{
      color: var(--main-theme-color);
      border-color: #ff5050;
    }
    [class^=el-icon-star-]{
      font-size: 20px;
      margin-right: 5px;
    }
  }
}
.fixedTabs{
  position: fixed;
  top: -100%;
  left: 0;
  right: 0;
  opacity: 0;
  z-index: 10;
  background-color: #fff;
  border-bottom: 2px solid var(--main-theme-color);
  transition: all 0.3s ease-out;
  &.show{
    top: 0;
    opacity: 1;
  }
  .tab{
    display: inline-block;
    padding: 0 20px;
    height: 40px;
    box-sizing: border-box;
    line-height: 40px;
    list-style: none;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    position: relative;
    cursor: pointer;
    &.shop{
      width: 200px;
      margin-right: 10px;
      text-align: center;
      background-color: #F5F5F5;
    }
    &.active{
      color: #FFFFFF;
      background-color: var(--main-theme-color);
    }
  }
}
.goods-tabs{
  background-color: #fff;
  min-height: 650px;
}

/** 商品评论 */
.goodsCommentList {
  padding: 15px;
  border-bottom: 1px solid #ECECEC;

  .commentListImg {
    width: 60px;
    height: 60px;
    border: 1px solid #ccc;
    padding: 0px;
    margin: 10px;
  }

  /deep/ span.el-rate__item {
    color: #e4393c !important;
  }

  /deep/ span.el-avatar.el-avatar--circle {
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important;
    vertical-align: middle;
    margin-right: 10px;
  }

  /deep/ .el-avatar > img {
    display: inline !important;
  }

  .goodsCommentList_content {
    font-size: 14px;
    margin-top: 10px;
  }

  .lastLine {
    display: flex;
    justify-content: space-between;

    .goodsCommentList_goodsName {
      color: #999;

      .goodsNameText {
        width: 260px;
        display: inline-block;
        vertical-align: top;
        margin-bottom: 10px;
      }
    }

    .goodsCommentList_opreate {
      span {
        color: #ccc;

        img {
          width: 25px;
          cursor: pointer;
        }
      }

      i.el-icon-chat-dot-round {
        font-size: 22px;
        vertical-align: sub;
        color: #ccc;
        margin-left: 15px;
        cursor: pointer;
      }
    }
  }

  .repalyBox {
    text-align: right;
    margin-top: 4px;
  }

  .redColor {
    color: var(--main-theme-color);
  }
}

/* 商品咨询 */
.goods_advisory {
  text-align: center;
  font-size: 18px;
}

.goods_advisory_input {
  width: 50%;
}

.advisory_button {
  background: var(--main-theme-color) !important;
  border: 1px solid var(--main-theme-color) !important;
  color: white !important;
  border-radius: 0;
}

.goods_adviceList {
  margin-top: 20px;
  .question-card{
    background-color: #fff;
  }
  .answer-card{
    background-color: #fff;
    padding: 10px;
    border-radius: 5px;
    /deep/ .el-row{
      margin: 10px 0;
    }
  }
  span.textRight {
    margin-right: 15px;
    font-size: 14px;
    color: #333;
    font-weight: 700;
  }

  .askText {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    font-size: 14px;
    color: #fff !important;
    text-align: center;
    display: inline-block;
    background: #d13030;
  }

  .replayText {
    background: #00833d;
  }

  .goods_adviceList_right {
    text-align: right;

    span.textRight {
      color: #999;
      font-size: 14px;
    }
  }
}

/* 提问狂 */
.dialog-footer {
  margin-top: 20px;
  display: block;
}

.addGoodsInfo {
  font-size: 24px;
}

.addCartBox .el-button--primary {
  color: #fff;
  background-color: #ff6700;
  border-color: #e65d00;
}

.cascaderArea.el-cascader {
  /deep/ input[disabled], /deep/ input[disabled="disabled"], /deep/ input[readonly], /deep/ input[readonly="readonly"] {
    background-color: white;
  }
}

.goodFoot{
  width: 790px;
}

</style>







// WEBPACK FOOTER //
// src/views/goodsList/goodsDetail.vue